module.exports = __webpack_public_path__ + "img/ryzs1.63d3b968.png";